<template>
    <div>
        <!-- Mobile -->
        <b-navbar toggleable sticky class="d-lg-none" ref="abc">
            <b-navbar-brand class="text-light" @click="$bvModal.show('versionModal')">
                <span>OmniStock OMS</span>
                <small v-if="$store.state.config.general.environment !== 'production'" class="text-warning pl-2">{{ $store.state.config.general.environment }}</small>
            </b-navbar-brand>
            
            <b-button variant="link" size="sm" class="search-modal-open-button px-2" @click="$bvModal.show('headerSearchModal')">
                <font-awesome-icon icon="search" class="text-light"/>
            </b-button>

            <b-navbar-toggle target="navbar-toggle-collapse">
                <font-awesome-icon icon="bars" class="text-light"/>
            </b-navbar-toggle>

            <b-collapse id="navbar-toggle-collapse" is-nav class="bg-midnight-bloom">
                <menu-vue></menu-vue>
            </b-collapse>

            <b-modal id="versionModal" hide-footer title="OMS Versie">{{ appVersion }}</b-modal>
            <b-modal id="headerSearchModal" hide-footer title="Zoeken" centered @shown="$refs['headerSearchComponent'].focus()">
                <header-search ref="headerSearchComponent" @success="$bvModal.hide('headerSearchModal')" :history-in-overlay="false"/>
            </b-modal>
        </b-navbar>

        <!-- Desktop -->
        <div class="app-header header-shadow header-text-light d-none d-lg-flex">
            <div class="app-header__logo">
                <div class="text-center mx-auto font-size-xlg">
                    <a href="/" class="text-white" id="versionPopover">OmniStock OMS</a>
                    <small v-if="$store.state.config.general.environment !== 'production'" class="text-warning pl-2">{{ $store.state.config.general.environment }}</small>

                    <b-popover target="versionPopover" placement="bottom" triggers="hover" delay="1500" :content="`versie: ${appVersion}`"/>
                </div>
            </div>
            <div class="app-header__mobile-menu">
            </div>
            <div class="app-header__menu">
                <span>
                    <button type="button" class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
                        <span class="btn-icon-wrapper">
                            <i class="fa fa-ellipsis-v fa-w-6"></i>
                        </span>
                    </button>
                </span>
            </div>
            <div class="app-header__content">
                <div class="app-header-left">
                    <header-search/>
                </div>

                <div class="app-header-right text-white">
                <span>
                  {{ $t('omt.gui.general.label.signed-in-as') }}:
                  <b-dropdown class="m-1" right toggle-class="btn-sm">
                      <template slot="button-content"><strong>{{ $store.state.user.name }}</strong></template>
                      <b-dropdown-text>
                          <a :href="$store.state.omniPortalBaseURL">OmniPortal</a>
                      </b-dropdown-text>
                  </b-dropdown>
                </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuickOrderSearch from "./QuickOrderSearch";
import menuVue from "@/components/Menu.vue"
import appVersion from "@/data/appVersion";
import HeaderSearch from "@/components/HeaderSearch.vue";
import {hasAllPermissions} from "@/helpers/permissions";

export default {
    name: "Header",
    components: {
        HeaderSearch,
        QuickOrderSearch,
        menuVue,
    },
    computed: {

        appVersion() {
            return appVersion
        },
    },
}
</script>

<style>
.version-popover {
    background: red;
}
.search-modal-open-button {
    border: solid 1px rgba(0, 0, 0, 0.1) !important;
}
</style>
